/* inbox: перевод строк интерфейса. Ключ — русская строка ровно как в коде. */
const d: Record<string, string> = {
  "База знаний ещё оценивает диалог": "The knowledge base is still scoring this conversation",
  "Оценка диалога в базе знаний": "Conversation score in the knowledge base",
  "база знаний: оценивается": "knowledge base: scoring",
  "база знаний: {score}/10": "knowledge base: {score}/10",
  "Без категории": "No category",
  "Без ответа {n} ч": "No reply for {n} h",
  "Без ответа дольше, чем задано в правилах диалогов": "Unanswered longer than the conversation rules allow",
  "Диалог закрыт автоматически: нет активности {n} {unit}": "Conversation closed automatically: no activity for {n} {unit}",
  "Закрыть диалог": "Close conversation",
  "Например: клиент взял паузу, вернётся после праздников": "For example: the customer paused, will be back after the holidays",
  "Тональность по оценке ИИ": "Sentiment as assessed by AI",
  "Чем закончился диалог? Заметка обязательна при закрытии — её увидит только команда.": "How did it end? A note is required to close — only the team will see it.",
  "дн.": "d",
  "негатив": "negative",
  "нед.": "wk",
  "нейтрально": "neutral",
  "позитив": "positive",
  "ч": "h",
  "Закрывая диалог вручную, продавец пишет, чем всё закончилось. Без заметки закрыть нельзя.": "When closing manually, the sales rep writes how it ended. Closing without a note is not allowed.",
  "Заметка при закрытии обязательна": "Note required on close",
  "Ключ OpenRouter на сервере не задан — итог ИИ пока не пишется.": "No OpenRouter key on the server — AI summaries are not written yet.",
  "Правила применяются ко всем диалогам: автозакрытие проверяется раз в час, итог ИИ пишется при закрытии, если на сервере есть ключ OpenRouter.": "Rules apply to all conversations: auto-close runs hourly, the AI summary is written on close when the server has an OpenRouter key.",
  "Спасибо за обращение! Если появятся вопросы — напишите, мы на связи.": "Thank you for reaching out! If you have any questions, just write — we’re here.",
  "Текст сообщения при закрытии": "Closing message text",
  "Только просмотр: правила меняют владелец и администраторы.": "View only: rules are changed by the owner and admins.",
  "Привет, {name}": "Hi, {name}",
  "Не прикладывать файлы шаблона": "Don’t attach the snippet files",
  "Нет шаблонов по запросу «/{q}»": "No snippets match “/{q}”",
  "Ответить в {channel} · Enter — отправить, Shift+Enter — перенос, «/» — шаблон": "Reply in {channel} · Enter to send, Shift+Enter for a new line, “/” for a snippet",
  "Файлы шаблона «{name}»:": "Files of snippet “{name}”:",
  "Шаблонов пока нет — их заводят в «Настройки → Шаблоны».": "No snippets yet — create them in Settings → Snippets.",
  "только файлы": "files only",
  "{name} берёт диалог": "{name} took the conversation",
  "{actor} передаёт диалог: {name}": "{actor} handed the conversation to {name}",
  "{name} снимает ответственного": "{name} removed the assignee",
  // ── общее / папки ──
  "Входящие": "Inbox",
  "входящие": "inbox",
  "Все": "All",
  "Мои": "Mine",
  "Совместные": "Shared",
  "Нераспределённые": "Unassigned",
  "Входящие звонки": "Incoming calls",
  "Создать AI-агента": "Create AI agent",
  "Ведёт бот": "Bot-led",
  "Закрытые": "Closed",
  "С архивом": "With archive",
  "Ответить": "Reply",
  "Ответить письмом от имени ящика · Enter — отправить, Shift+Enter — перенос, «/» — шаблон": "Reply by email from the mailbox · Enter — send, Shift+Enter — new line, “/” — template",
  "Переслать в другой диалог": "Forward to another dialog",
  "Переслать:": "Forward:",
  "Не пересылать": "Do not forward",
  "Кому: имя, компания или телефон": "To: name, company or phone",
  "Диалогов не найдено": "No dialogs found",
  "этот диалог": "this dialog",
  "Переслано в «{name}»": "Forwarded to “{name}”",
  "Не удалось переслать в «{name}» — проверьте подключение канала.": "Could not forward to “{name}” — check the channel connection.",
  "Файл «{name}» больше {n} МБ — отправьте ссылкой или сожмите.": "File “{name}” is over {n} MB — send a link or compress it.",
  "Файл больше {n} МБ — отправьте ссылкой или сожмите.": "File is over {n} MB — send a link or compress it.",
  "Фото, видео, аудио или документ любого формата — до {n} МБ": "Photo, video, audio or a document of any format — up to {n} MB",
  "Отправить файлы: фото, видео, голосовое или документ любого формата, до {n} МБ каждый; можно несколько сразу": "Send files: photo, video, voice or a document of any format, up to {n} MB each; several at once is fine",
  "больше {n} МБ — WhatsApp получит как документ": "over {n} MB — WhatsApp will receive it as a document",
  "все диалоги": "all dialogs",
  "только открытые": "open only",
  "Закрытые диалоги (архив Wazzup, старая почта) тоже в списке и в счётчиках папок и плиток": "Closed dialogs (Wazzup archive, old mail) are included in the list and in folder and tile counters",
  "Привязка": "Linked to",
  "С контактом": "With a contact",
  "С компанией": "With a company",
  "Без контакта": "No contact",
  "Все менеджеры": "All managers",
  "Закрыт": "Closed",
  "Этап": "Stage",
  "Команда": "Team",
  "Жизненный цикл": "Lifecycle",
  "Командные входящие": "Team inboxes",
  "Команды создаются в настройках": "Teams are created in Settings",
  "Каналы": "Channels",
  "Контакты": "Contacts",
  "Контакт": "Contact",
  "Дашборд": "Dashboard",
  "AI-агенты": "AI agents",
  "AI-агент": "AI agent",
  "Рассылки": "Broadcasts",
  "Рабочие процессы": "Workflows",
  "Отчеты": "Reports",
  "Настройки": "Settings",
  "Общие сведения": "General",
  "Чаты": "Chats",
  "Звонки": "Calls",
  "Без ответа": "Awaiting reply",
  "Ждёт ответа": "Awaiting reply",
  "Бот": "Bot",
  "бот": "bot",
  "бот {name}": "bot {name}",
  "не назначен": "unassigned",
  "Не назначен": "Unassigned",
  "Сотрудник": "Staff",
  "Я": "Me",
  "Вы": "You",
  "Вы:": "You:",
  "Другой сотрудник": "Another teammate",
  "Нет сообщений": "No messages",
  "Вчера": "Yesterday",
  "Сегодня": "Today",
  "Пн": "Mon",
  "Почта": "Email",
  "Отмена": "Cancel",
  "Сохранить": "Save",
  "Готово": "Done",
  "Позже": "Later",
  "Закрыть": "Close",
  "Открыть снова": "Reopen",
  "Закрыть окно": "Close window",
  "Сбросить": "Reset",
  "Сбросить поиск": "Reset search",
  "Перехватить": "Take over",
  "Взять себе": "Take",
  "Ответственный": "Assignee",
  "Ответственный за диалог": "Conversation assignee",
  "Ответственный назначен": "Assignee set",
  "Диалог снят с ответственного": "Conversation unassigned",
  "Переподключить": "Reconnect",
  "Подключить канал": "Connect a channel",
  "Подключить звонки": "Connect calls",
  "Подключить WhatsApp →": "Connect WhatsApp →",
  "Подключите WhatsApp — диалоги появятся здесь сами": "Connect WhatsApp and conversations will appear here automatically",
  "Раздел пока не открывается": "This section is not available yet",
  "Раздел «{name}» пока не открывается": "The “{name}” section is not available yet",

  // ── статусы каналов (inbox-api) ──
  "Создан": "Created",
  "Ждёт сканирования QR-кода": "Waiting for QR code scan",
  "Ждёт код на телефоне": "Waiting for the code on the phone",
  "Подключается…": "Connecting…",
  "Подключён": "Connected",
  "Не авторизовано": "Not authorised",
  "Отключён": "Disconnected",
  "Ошибка подключения": "Connection error",
  "Архив": "Archive",
  "Архив Wazzup из Zoho CRM: только чтение. Если клиент напишет снова, диалог появится во «Входящих» подключённого номера.": "Wazzup archive from Zoho CRM: read-only. If the customer writes again, the conversation will appear in the Inbox of the connected number.",
  "канал не подключён": "channel not connected",
  "каналы не подключены": "no channels connected",
  "диалогов": "conversation|conversations",
  "каналов": "channel|channels",
  "WhatsApp {names}: сеанс завершён — новые сообщения не приходят.": "WhatsApp {names}: session ended — new messages are not coming in.",

  // ── окно «Входящие» (inboxapp) ──
  "Поиск по входящим": "Search inbox",
  "Поиск по диалогам": "Search conversations",
  "Новый диалог": "New conversation",
  "С какого ящика": "From which mailbox",
  "Адрес почты клиента": "Customer's email address",
  "Нет подключённого WhatsApp или почты — сначала подключите канал в разделе «Каналы».": "No WhatsApp or mailbox connected — connect a channel in “Channels” first.",
  "Сначала подключите WhatsApp или почту в разделе «Каналы»": "Connect WhatsApp or a mailbox in “Channels” first",
  "Письмо уйдёт от имени выбранного ящика, файлы — вложениями. Если контакт с таким адресом уже есть, диалог привяжется к нему.": "The email goes out from the selected mailbox, files as attachments. If a contact with this address exists, the conversation links to it.",
  "Тема письма": "Subject",
  "Текст письма": "Email text",
  "Текст письма…": "Email text…",
  "Первое сообщение — можно оставить пустым": "First message — may be left empty",
  "Письмо отправлено": "Email sent",
  "Сообщение отправлено": "Message sent",
  "Написать клиенту первым": "Message a customer first",
  "Имя, компания или телефон": "Name, company or phone",
  "Сортировка диалогов": "Sort conversations",
  "Показать только диалоги без ответа": "Show only conversations awaiting reply",
  "Поиск по имени, компании, телефону или тексту последнего сообщения": "Search by name, company, phone or last message text",
  "Ничего не нашлось": "Nothing found",
  "Попробуйте другое слово или снимите фильтр «Без ответа».": "Try another word or turn off the “Awaiting reply” filter.",
  "Показать ещё ({n})": "Show more ({n})",
  "Выберите диалог": "Select a conversation",
  "Слева {n} диалогов в папке «{folder}».": "{n} conversations in the “{folder}” folder on the left.",
  "На этапе «{name}» пусто": "Nothing at the “{name}” stage",
  "Сюда попадут диалоги с контактами на этом этапе жизненного цикла.": "Conversations with contacts at this lifecycle stage will appear here.",
  "У команды «{name}» нет диалогов": "Team “{name}” has no conversations",
  "Диалоги попадают сюда, когда их назначают команде или контакт закреплён за ней.": "Conversations land here when assigned to the team or when the contact belongs to it.",
  "Бот сейчас никого не ведёт": "The bot is not handling anyone right now",
  "Сюда попадают диалоги без ответственного в каналах, где с телефона отвечает бот. Имя бота задаётся в «Каналах».": "Unassigned conversations from channels where a bot replies from the phone land here. The bot name is set in Channels.",
  "Закрытых диалогов нет": "No closed conversations",
  "Закрытые диалоги остаются здесь: история, заметки и вложения не теряются.": "Closed conversations stay here: history, notes and attachments are kept.",
  "Сообщение не отправлено: {error}": "Message not sent: {error}",
  "Заметка добавлена — клиент её не увидит": "Note added — the customer will not see it",
  "Файл не отправлен — проверьте подключение канала.": "File not sent — check the channel connection.",
  "Диалог закрыт — он останется в папке «Закрытые»": "Conversation closed — it stays in the Closed folder",
  "Диалог открыт снова": "Conversation reopened",
  "Диалог открыт — напишите первое сообщение": "Conversation opened — write the first message",
  "AI-агент «{role}» появится на этапе AI — пока он не создаётся": "The “{role}” AI agent will arrive in the AI phase — it is not created yet",
  "Написать первым": "Message first",
  "С какого номера": "From which number",
  "Телефон клиента": "Customer phone",
  "Если контакт с таким номером уже есть, диалог привяжется к нему. Писать первым можно, но массовые рассылки с обычного номера WhatsApp блокирует.": "If a contact with this number already exists, the conversation will be linked to it. You can message first, but WhatsApp blocks bulk messaging from a regular number.",
  "Открыть диалог": "Open conversation",
  "Агент отвечает первым, пока продавцы заняты, и передаёт человеку сложные вопросы вместе с контекстом диалога.": "The agent replies first while salespeople are busy and hands complex questions to a human along with the conversation context.",
  "Чем займётся агент": "What the agent will do",
  "Создать агента": "Create agent",
  "Папки входящих и жизненный цикл — один список: этапы продаж сразу становятся папками, где лежат диалоги нужных контактов.": "Inbox folders and the lifecycle are one list: sales stages become folders holding the conversations of the right contacts.",

  // ── панель переписки (inboxapp-pane) ──
  "{n} КБ": "{n} KB",
  "{n} МБ": "{n} MB",
  "Не отправлено": "Not sent",
  "Не отправлено: {error}": "Not sent: {error}",
  "не отправлено": "not sent",
  "Отправляется": "Sending",
  "Отправлено": "Sent",
  "Прочитано": "Read",
  "Доставлено": "Delivered",
  "Фото": "Photo",
  "Стикер": "Sticker",
  "Геопозиция": "Location",
  "Скачать": "Download",
  "Файл недоступен: вложение из старой истории": "File unavailable: attachment from old history",
  "файл не сохранён": "file not saved",
  "Заметка для команды": "Team note",
  "Вложение": "Attachment",
  "вложение": "attachment",
  "с телефона": "from phone",
  "К списку диалогов": "Back to conversations",
  "Открыть карточку контакта": "Open contact card",
  "Номер не найден среди контактов": "Number not found among contacts",
  "без контакта": "no contact",
  "Диалог ведёт бот {name}. Перехватить: диалог и клиент переходят к вам": "Bot {name} is handling this conversation. Take over: the conversation and the customer move to you",
  "Диалог и клиент переходят к вам": "The conversation and the customer move to you",
  "Прокрутите вверх, чтобы загрузить более ранние сообщения": "Scroll up to load earlier messages",
  "Сообщений пока нет — напишите первым.": "No messages yet — write first.",
  "Ответ на:": "Reply to:",
  "Не отвечать на сообщение": "Cancel reply",
  "Убрать файл": "Remove file",
  "Режим просмотра: отвечать в диалогах может сотрудник с правом записи.": "View mode: only a teammate with write access can reply in conversations.",
  "Внутренняя заметка: клиент её не увидит": "Internal note: the customer will not see it",
  "Прикрепить файл": "Attach file",
  "Внутренняя заметка — клиент её не увидит. @имя — упомянуть коллегу": "Internal note — the customer will not see it. @name to mention a teammate",
  "Подпись к файлу (необязательно)": "File caption (optional)",
  "Ответить в {channel} · Enter — отправить, Shift+Enter — перенос": "Reply in {channel} · Enter to send, Shift+Enter for a new line",
  "Сохранить заметку": "Save note",
  "Отправить сообщение": "Send message",

  // ── демо-макет «Входящие» (inbox) ──
  "2 канала · онлайн": "2 channels · online",
  "Имя, телефон или @ник": "Name, phone or @username",
  "Ничего не нашлось. Измените фильтр или запрос.": "Nothing found. Change the filter or the query.",
  "{shown} из {total} диалогов": "{shown} of {total} conversations",
  "Сейчас новые сверху — переключить на старые": "Newest first — switch to oldest first",
  "Сейчас старые сверху — переключить на новые": "Oldest first — switch to newest first",
  "Новые сверху": "Newest first",
  "Старые сверху": "Oldest first",
  "Канал: {channel}": "Channel: {channel}",
  "Отвечает": "Replying",
  "Заметка": "Note",
  "Забрать у бота": "Take from bot",
  "Передать боту": "Hand to bot",
  "Отправить в": "Send to",
  "канал клиента": "customer's channel",
  "сообщение уйдёт в {channel}": "message will go to {channel}",
  "Внутренняя заметка — клиент её не увидит": "Internal note — the customer will not see it",
  "Написать в {channel}": "Write in {channel}",
  "Демо-режим: сообщения остаются в этом макете и не уходят клиенту.": "Demo mode: messages stay in this mock-up and are not sent to the customer.",
  "Выберите диалог слева": "Select a conversation on the left",
  "Бот «Входящие»": "Bot “Inbox”",
  "Диалог передан боту": "Conversation handed to the bot",
  "Диалог возвращён продавцу": "Conversation returned to the salesperson",

  // ── настройки «Диалоги» (conversations) ──
  "настройки → входящие → диалоги": "settings → inbox → conversations",
  "Категорий: {n}": "Categories: {n}",
  "Категория {n}": "Category {n}",
  "категорий": "category|categories",
  "Доступы": "Access",
  "Правила закрытия и категории меняет администратор. Продавцы закрывают диалоги вручную.": "Closing rules and categories are managed by an admin. Salespeople close conversations manually.",
  "Диалоги": "Conversations",
  "Настройте, как обрабатываются и закрываются диалоги в рабочем пространстве.": "Set up how conversations are handled and closed in the workspace.",
  "Демо-режим: подсказки по настройке диалогов в макете недоступны": "Demo mode: conversation setup tips are not available in the mock-up",
  "Узнать больше": "Learn more",
  "Автозакрытие диалогов": "Auto-close conversations",
  "Диалог закрывается после периода неактивности. Новое сообщение снова открывает его.": "A conversation closes after a period of inactivity. A new message reopens it.",
  "Автозакрытие выключено — диалоги остаются открытыми до ручного закрытия": "Auto-close is off — conversations stay open until closed manually",
  "Автозакрытие включено — неактивные диалоги будут закрываться автоматически": "Auto-close is on — inactive conversations will close automatically",
  "Закрывать через": "Close after",
  "Через сколько закрывать диалог": "Close the conversation after",
  "Единица времени автозакрытия": "Auto-close time unit",
  "Укажите целое число от 1 до 365 — иначе диалоги не закроются.": "Enter a whole number from 1 to 365 — otherwise conversations will not close.",
  "Сейчас: диалог без ответа закроется через {n} {unit}.": "Currently: an unanswered conversation closes after {n} {unit}.",
  "часов": "hours",
  "час": "hour",
  "часа": "hours",
  "дней": "day|days",
  "день": "day",
  "дня": "days",
  "недель": "weeks",
  "неделю": "week",
  "недели": "weeks",
  "Автоматические заметки при закрытии": "Automatic notes on close",
  "При закрытии AI определяет категорию и собирает краткое содержание диалога.": "On close, AI picks a category and writes a short summary of the conversation.",
  "Автозаметки выключены — при закрытии диалога заметка не создаётся": "Auto-notes are off — no note is created when a conversation closes",
  "Автозаметки включены — к закрытому диалогу добавится summary": "Auto-notes are on — a summary will be added to closed conversations",
  "Категория диалога": "Conversation category",
  "AI выбирает самую близкую тему. Понятные названия и описания помогают не путать категории.": "AI picks the closest topic. Clear names and descriptions help keep categories apart.",
  "Управление": "Manage",
  "Без названия": "Untitled",
  "без названия": "untitled",
  "нажмите на тег, чтобы изменить название и описание": "click a tag to edit its name and description",
  "Тональность диалога": "Conversation sentiment",
  "При закрытии AI проверяет сообщения клиента и помечает тон — положительный, нейтральный или отрицательный — с объяснением в одну строку.": "On close, AI reviews the customer's messages and marks the tone — positive, neutral or negative — with a one-line explanation.",
  "Оценка тональности выключена — новые диалоги будут без метки": "Sentiment scoring is off — new conversations will have no label",
  "Оценка тональности включена — закрытые диалоги получат метку тона": "Sentiment scoring is on — closed conversations get a tone label",
  "Расширенные настройки": "Advanced settings",
  "Не закрывать диалоги с непрочитанными": "Keep conversations with unread messages open",
  "Если клиент написал, а продавец не открыл диалог, автозакрытие ждёт и не срабатывает.": "If the customer wrote and the salesperson has not opened the conversation, auto-close waits and does not fire.",
  "Не закрывать диалоги с непрочитанными сообщениями": "Keep conversations with unread messages open",
  "Сообщение клиенту при закрытии": "Message to the customer on close",
  "Отправлять короткое «Спасибо за обращение» перед тем, как диалог закроется.": "Send a short “Thank you for reaching out” before the conversation closes.",
  "Напоминание о диалоге без ответа": "Unanswered conversation reminder",
  "Через сколько часов подсвечивать такой диалог в ленте.": "After how many hours to highlight such a conversation in the feed.",
  "{n} ч": "{n} h",
  "Есть несохранённые изменения": "You have unsaved changes",
  "Все изменения сохранены": "All changes saved",
  "Как это работает": "How it works",
  "Демо-режим: настройки меняются только в макете — существующие диалоги, отчёты и контакты не затрагиваются.": "Demo mode: settings change only in the mock-up — existing conversations, reports and contacts are not affected.",
  "Закрыть окно категорий": "Close categories window",
  "Категории диалогов": "Conversation categories",
  "Что AI выбирает при закрытии": "What AI picks on close",
  "Чем точнее описание, тем реже диалоги попадают в «Другое». Изменения применятся после «Сохранить».": "The more precise the description, the fewer conversations end up in “Other”. Changes apply after Save.",
  "Название категории": "Category name",
  "Удалить категорию {name}": "Delete category {name}",
  "Описание категории": "Category description",
  "Когда выбирать эту категорию": "When to pick this category",
  "Добавить категорию": "Add category",
  "При удалении категории её диалоги не пропадают — они переходят в «Другое».": "Deleting a category does not lose its conversations — they move to “Other”.",
  "Категории обновлены — не забудьте сохранить настройки диалогов": "Categories updated — remember to save conversation settings",
  "Последнюю категорию удалить нельзя — в списке должна остаться хотя бы одна": "The last category cannot be deleted — at least one must remain",
  "Категория «{name}» удалена — диалоги из неё получат «Другое»": "Category “{name}” deleted — its conversations will get “Other”",
  "Настройки диалогов сохранены — новые правила начнут работать со следующего диалога": "Conversation settings saved — new rules apply from the next conversation",
  "Изменения отменены — настройки вернулись к сохранённому виду": "Changes discarded — settings reverted to the saved state",
  "В демо открыт только раздел «Диалоги» — остальные настройки не меняются": "Only the Conversations section is open in the demo — other settings do not change",

  // ── моки: окно «Входящие» ──
  "3 ноября 2026": "3 November 2026",
  "Виктор": "Viktor",
  "В": "V",
  "Администратор": "Admin",
  "Менеджер": "Manager",
  "Агент": "Agent",
  "Новый лид": "New lead",
  "Горячий лид": "Hot lead",
  "Оплата": "Payment",
  "Клиент": "Customer",
  "Открытые, новые": "Open, newest",
  "Открытые, старые": "Open, oldest",
  "С непрочитанными": "Unread",
  "Похоже, входящие пусты": "Looks like the inbox is empty",
  "Вы сможете отвечать здесь, когда придут новые сообщения.": "You will be able to reply here once new messages arrive.",
  "Вам пока ничего не назначено": "Nothing is assigned to you yet",
  "Когда руководитель закрепит диалог за вами, он появится в этой папке.": "When a manager assigns a conversation to you, it will appear in this folder.",
  "Совместных диалогов нет": "No shared conversations",
  "Здесь собираются переписки, в которых участвуют несколько сотрудников.": "Conversations with several teammates involved are collected here.",
  "Входящих звонков нет": "No incoming calls",
  "Подключите телефонию — звонки появятся здесь вместе с записью разговора.": "Connect telephony and calls will appear here along with recordings.",
  "На этапе «Новый лид» пусто": "Nothing at the “New lead” stage",
  "Сюда попадут диалоги с контактами, которые только начали общение.": "Conversations with contacts who have just started talking will appear here.",
  "На этапе «Горячий лид» пусто": "Nothing at the “Hot lead” stage",
  "Здесь диалоги, где клиент уже готов обсуждать условия и сроки.": "Conversations where the customer is ready to discuss terms and timing.",
  "На этапе «Оплата» пусто": "Nothing at the “Payment” stage",
  "Сюда попадают переписки, где клиент ждёт счёт или подтверждение оплаты.": "Conversations where the customer is waiting for an invoice or payment confirmation land here.",
  "Среди клиентов пока пусто": "No customers yet",
  "Здесь остаются диалоги с теми, кто уже купил — для поддержки и повторных продаж.": "Conversations with those who already bought stay here — for support and repeat sales.",
  "Виктор Лебедев": "Viktor Lebedev",
  "Дмитрий Орлов": "Dmitry Orlov",
  "Алексей Ковалёв": "Alexey Kovalev",
  "Ольга Смирнова": "Olga Smirnova",
  "Агент отвечает в WhatsApp, Telegram, почте и онлайн-чате.": "The agent replies in WhatsApp, Telegram, email and live chat.",
  "Источники знаний": "Knowledge sources",
  "Опирается на прайсы, регламенты и шаблоны ответов компании.": "Relies on the company's price lists, policies and reply templates.",
  "Передача человеку": "Handover to a human",
  "Сложный вопрос сразу уходит продавцу с заметкой о контексте.": "A complex question goes straight to a salesperson with a context note.",
  "Отвечать на первые сообщения": "Reply to first messages",
  "Собирать заявки": "Collect requests",
  "Записывать на консультацию": "Book consultations",
  "Поддерживать клиентов": "Support customers",
  "Папки вместо хаоса": "Folders instead of chaos",
  "Диалоги раскладываются по ответственным и этапам жизненного цикла — не нужно искать вручную.": "Conversations are sorted by assignee and lifecycle stage — no manual searching.",
  "Фильтр «Без ответа»": "“Awaiting reply” filter",
  "Одно переключение оставляет только переписки, где последним писал клиент.": "One toggle leaves only conversations where the customer wrote last.",
  "Звонки рядом с чатами": "Calls next to chats",
  "Вкладка «Звонки» показывает историю разговоров в той же папке, что и переписка.": "The Calls tab shows call history in the same folder as the chat.",

  // ── моки: демо-диалоги ──
  "Здравствуйте! Отправляю прайс — посмотрите, пожалуйста.": "Hello! Sending the price list — please take a look.",
  "Доставка по Москве — 1–2 дня, по России — 3–5 дней.": "Delivery in Moscow — 1–2 days, across Russia — 3–5 days.",
  "Счёт на юрлицо выставим в течение часа.": "We will issue a company invoice within an hour.",
  "Могу закрепить этот диалог за вашим менеджером.": "I can assign this conversation to your account manager.",
  "Анна Смирнова": "Anna Smirnova",
  "Кафе «Пудра»": "Pudra Cafe",
  "Новый заказ": "New order",
  "Опт": "Wholesale",
  "Здравствуйте! Нужен прайс на посуду для кафе — тарелки и стаканы.": "Hello! I need a price list for cafe tableware — plates and glasses.",
  "Добрый день! Отправляю прайс: 28 позиций, цены за комплект из 6 штук.": "Good afternoon! Sending the price list: 28 items, prices per set of 6.",
  "Спасибо, посмотрю. А доставка в Казань до пятницы возможна?": "Thanks, I will take a look. Can you deliver to Kazan by Friday?",
  "И можно счёт на юрлицо?": "And could you invoice our company?",
  "Игорь Лебедев": "Igor Lebedev",
  "ООО «Ромашка»": "Romashka LLC",
  "Бот «Запись»": "Bot “Booking”",
  "Запись": "Booking",
  "Здравствуйте, хочу записаться на консультацию.": "Hello, I would like to book a consultation.",
  "Диалог передан боту «Запись на консультацию»": "Conversation handed to the “Consultation booking” bot",
  "Здравствуйте! Выберите удобный день: 28, 29 или 30 октября.": "Hello! Pick a convenient day: 28, 29 or 30 October.",
  "29 октября": "29 October",
  "Отлично, 29 октября в 15:00. Подтвердите, пожалуйста, номер телефона.": "Great, 29 October at 15:00. Please confirm your phone number.",
  "Мария Ким": "Maria Kim",
  "Оптовая закупка": "Wholesale purchase",
  "Доставка": "Delivery",
  "Добрый день! Заказ №4812 уже отправлен?": "Good afternoon! Has order No. 4812 been shipped yet?",
  "Здравствуйте, Мария! Да, отправили вчера вечером, трек придёт на почту до 18:00.": "Hello Maria! Yes, it shipped last night; the tracking number will reach your email by 18:00.",
  "Спасибо!": "Thank you!",
  "Всегда рады помочь.": "Always happy to help.",
  "Сергей Петров": "Sergey Petrov",
  "Договор №17": "Contract No. 17",
  "Счёт": "Invoice",
  "Срочно": "Urgent",
  "Здравствуйте, нужен счёт на оплату по договору №17.": "Hello, I need an invoice for payment under contract No. 17.",
  "Просит счёт на юрлицо, оплата должна пройти до пятницы.": "Asks for a company invoice; payment must go through by Friday.",
  "Когда сможете выставить?": "When can you issue it?",
  "Елена Волкова": "Elena Volkova",
  "Онлайн-школа": "Online school",
  "Бот «Заявки»": "Bot “Requests”",
  "Заявка": "Request",
  "Хочу узнать про тариф для команды из 12 человек.": "I would like to know about a plan for a team of 12.",
  "Диалог передан боту «Сбор заявок»": "Conversation handed to the “Request intake” bot",
  "Подскажите, пожалуйста, сферу деятельности и удобное время для звонка.": "Please tell us your line of business and a convenient time for a call.",
  "Онлайн-школа, удобно завтра после 14:00.": "Online school, tomorrow after 14:00 works.",
  "Артём Кузнецов": "Artem Kuznetsov",
  "ИП Кузнецов": "Kuznetsov (sole trader)",
  "Возврат": "Return",
  "Одна позиция пришла с трещиной, как оформить возврат?": "One item arrived cracked, how do I arrange a return?",
  "Пришлите, пожалуйста, фото упаковки и самой позиции — оформим замену сегодня.": "Please send photos of the packaging and the item — we will arrange a replacement today.",
  "Отправил фото.": "Sent the photos.",
  "Принято, замена уедет завтра утром. Приносим извинения за доставленные неудобства.": "Got it, the replacement ships tomorrow morning. We apologise for the inconvenience.",
  "Ольга Соколова": "Olga Sokolova",
  "Студия «Тон»": "Ton Studio",
  "Консультация": "Consultation",
  "Здравствуйте! Можно ли подключить два номера WhatsApp на один аккаунт?": "Hello! Can two WhatsApp numbers be connected to one account?",
  "Да, в Hub можно добавить несколько номеров и раздать их продавцам по ролям.": "Yes, in Hub you can add several numbers and assign them to salespeople by role.",
  "А аналитика по каждому номеру будет отдельная?": "Will analytics be separate for each number?",
  "Дмитрий Волков": "Dmitry Volkov",
  "ООО «Сфера»": "Sfera LLC",
  "Подскажите, есть ли API для выгрузки диалогов в нашу CRM?": "Is there an API to export conversations to our CRM?",
  "Да, есть REST API и вебхуки на новые сообщения. Ключи выдаёт администратор аккаунта.": "Yes, there is a REST API and webhooks for new messages. Keys are issued by the account admin.",
  "Отлично, тогда берём.": "Great, we will take it.",

  // ── моки: настройки «Диалоги» ──
  "Рабочее пространство": "Workspace",
  "Настройки пользователей": "User settings",
  "Настройки команды": "Team settings",
  "Приложения": "Apps",
  "Интеграции": "Integrations",
  "Виджеты": "Widgets",
  "Настройки входящих": "Inbox settings",
  "Поля контактов": "Contact fields",
  "Шаблоны": "Snippets",
  "Теги": "Tags",
  "Данные": "Data",
  "Файлы": "Files",
  "Импорт контактов": "Import contacts",
  "Экспорт данных": "Export data",
  "Общие вопросы": "General questions",
  "Всё, что не подошло к другим категориям: приветствие, уточнение цены, условия работы.": "Anything that does not fit other categories: greetings, price enquiries, terms of work.",
  "Другое": "Other",
  "Редкие обращения, для которых пока нет своей категории.": "Rare enquiries that do not have their own category yet.",
  "Счета, способы оплаты, возвраты и вопросы по закрывающим документам.": "Invoices, payment methods, refunds and closing documents.",
  "Продажи": "Sales",
  "Запрос коммерческого предложения, демо, обсуждение объёма и сроков.": "Quote requests, demos, discussing volume and timing.",
  "Диалог — это переписка": "A conversation is a thread",
  "Диалог связывает клиента с командой в конкретном канале: WhatsApp, Telegram или почта.": "A conversation links a customer with the team in a specific channel: WhatsApp, Telegram or email.",
  "Диалог открывается": "A conversation opens",
  "Когда клиент пишет первым или сотрудник начинает переписку с контактом.": "When a customer writes first or a teammate starts a thread with a contact.",
  "Диалог закрывается": "A conversation closes",
  "Когда вопрос решён или активности нет дольше заданного срока.": "When the issue is resolved or there is no activity beyond the set period.",
  "Контекст сохраняется": "Context is kept",
  "Закрытые диалоги остаются в карточке клиента: история, заметки и оценка тональности.": "Closed conversations stay on the customer card: history, notes and sentiment.",
  "Клиент Books:": "Books customer:",
  "{n} счетов": "{n} invoices",
  "долг {sum}": "due {sum}",
  "Похоже, это клиент Books «{name}» — совпал телефон.": "Looks like Books customer “{name}” — the phone number matches.",
  "Связать": "Link",
  "Бот {name}": "Bot {name}",
  "{n} диалогов · живые данные": "{n} conversations · live data",
  "Диалогов пока нет — подключите WhatsApp в «Каналах».": "No conversations yet — connect WhatsApp in “Channels”.",
  "Живые данные: сообщения уходят клиенту. Полный интерфейс — во «Входящих».": "Live data: messages are sent to the customer. The full interface is in the Inbox.",
  "Назначен по продавцу Zoho «{sp}»: {name}": "Assigned by Zoho salesperson “{sp}”: {name}",
  "Продавец по данным Zoho; сотрудник Hub ещё не привязан — Настройки → Zoho → «Продавцы Zoho»": "Salesperson from Zoho; no Hub user linked yet — Settings → Zoho → “Zoho salespersons”",
  "продавец Zoho: {name}": "Zoho salesperson: {name}",
  "Спросить базу знаний": "Ask the knowledge base",
  "прайсы, каталоги, договоры, счета, реквизиты": "price lists, catalogs, contracts, invoices, company details",
  "Цена и наличие товара": "Product price and availability",
  "Последние счета и договоры этого клиента": "This customer's latest invoices and contracts",
  "Реквизиты компании для счёта": "Company details for an invoice",
  "Вставить в ответ": "Insert into reply",
  "База знаний ищет ответ по документам…": "The knowledge base is searching the documents…",
  "Уточнить вопрос…": "Follow-up question…",
  "Например: цена стула Lissandra и срок поставки": "For example: Lissandra chair price and lead time",
  "Вопрос базе знаний": "Question to the knowledge base",
  "Спросить базу знаний: цены, наличие, договоры и счета клиента, реквизиты — ответ можно вставить клиенту": "Ask the knowledge base: prices, stock, the customer's contracts and invoices, company details — the answer can be inserted into the reply",
  "База знаний 3Jar · baza.starec.ai": "3Jar knowledge base · baza.starec.ai",
  "подключена": "connected",
  "Прайсы, каталоги, договоры, инвойсы и проформы, реквизиты компании — всё, что загружено в базу знаний. Менеджеры спрашивают её прямо из работы, ничего не копируя:": "Price lists, catalogs, contracts, invoices and proformas, company details — everything uploaded to the knowledge base. Managers ask it right from their work, without copying anything:",
  "во «Входящих» — кнопка с книгой рядом с полем ответа: вопрос уходит вместе с последними сообщениями клиента, ответ со ссылками на документы вставляется в ответ одним нажатием;": "in the Inbox — the book button next to the reply box: the question goes with the customer's latest messages, and the answer with document links is inserted into the reply in one click;",
  "в карточке компании — «Спросить базу знаний» в шапке, а во вкладке «Заказы, счета и оплаты» — документы клиента из базы;": "in the company card — “Ask the knowledge base” in the header, and the customer's documents from the base in the “Orders, invoices and payments” tab;",
  "переписка WhatsApp и Telegram сама уходит в базу на оценку — балл виден в шапке диалога.": "WhatsApp and Telegram conversations are sent to the base for scoring automatically — the score shows in the conversation header.",
  "База отвечает с правами сотрудника по его рабочей почте и только по документам компании, контрагентов и товаров — без личных дел, окладов и чужих диалогов. Каждый вопрос пишется в журнал.": "The base answers with the employee's own rights (matched by work email) and only from company, counterparty and product documents — no personnel files, salaries or other people's conversations. Every question is logged.",
  "Проверить: задать вопрос": "Try it: ask a question",
};
export default d;
